export const arrayToObject = array =>
    array.reduce((obj, item) => {
        obj[item.id] = item.value
        return obj
    }, {})
